import { useContext } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';

const SummaryStatsPanel = () => {
    const { state } = useContext(SmartContext);
    const summary = state.data.summary;

    return (
        <div className="col-12">
            <div className="x-scroll pt-1 mb-0">
                <div className="w-1140">
                    <div className="row g-3 mx-0">
                        <div className="col">
                            <div className="bg-white p-3 custom-shadow h-100 radius-6">
                                <div className="row g-3 align-items-center">
                                    <div className="col font-14 font-500 text-gray-64">Total Alumni</div>
                                    <div className="col-auto">
                                        <div className="bg-primary bg-opacity-10 ratio-32 rounded-3 d-flex justify-content-center align-items-center">
                                            <i className="bi bi-people-fill text-primary font-18"></i>
                                        </div>
                                    </div>
                                </div>
                                <p className="font-30 font-600 mb-0">{summary?.totalAlumni}</p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="bg-white p-3 custom-shadow h-100 radius-6">
                                <div className="row g-3 align-items-center">
                                    <div className="col font-14 font-500 text-gray-64">Alumni Outreached</div>
                                    <div className="col-auto">
                                        <div className="bg-success bg-opacity-10 ratio-32 rounded-3 d-flex justify-content-center align-items-center">
                                            <i className="bi bi-telephone-outbound-fill text-success font-18"></i>
                                        </div>
                                    </div>
                                </div>
                                <p className="font-30 font-600 mb-0">{summary?.alumniOutreached}</p>
                                <span className="font-14 font-400 text-gray-4b mb-0">{summary?.outreachedPercent}% coverage</span>
                            </div>
                        </div>
                        <div className="col">
                            <div className="bg-white p-3 custom-shadow h-100 radius-6">
                                <div className="row g-3 align-items-center">
                                    <div className="col font-14 font-500 text-gray-64">Total Attempts</div>
                                    <div className="col-auto">
                                        <div className="bg-primary bg-opacity-10 ratio-32 rounded-3 d-flex justify-content-center align-items-center">
                                            <i className="bi bi-share text-primary font-18"></i>
                                        </div>
                                    </div>
                                </div>
                                <p className="font-30 font-600 mb-0">{summary?.totalAttempts}</p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="bg-white p-3 custom-shadow h-100 radius-6">
                                <div className="row g-3 align-items-center">
                                    <div className="col font-14 font-500 text-gray-64">Outreach Duration</div>
                                    <div className="col-auto">
                                        <div className="bg-warning bg-opacity-10 ratio-32 rounded-3 d-flex justify-content-center align-items-center">
                                            <i className="bi bi-clock text-orange font-18"></i>
                                        </div>
                                    </div>
                                </div>
                                <p className="font-30 font-600 mb-0">{summary?.outreachDuration}</p>
                                {summary?.averagePerCall && (
                                    <span className="font-14 font-400 text-gray-4b mb-0">Avg {summary?.averagePerCall}</span>
                                )}
                            </div>
                        </div>
                        <div className="col">
                            <div className="bg-white p-3 custom-shadow h-100 radius-6">
                                <div className="row g-3 align-items-center">
                                    <div className="col font-14 font-500 text-gray-64">Cross-channel</div>
                                    <div className="col-auto">
                                        <div className="bg-bs-purple bg-opacity-10 ratio-32 rounded-3 d-flex justify-content-center align-items-center">
                                            <i className="bi bi-share text-purple font-18"></i>
                                        </div>
                                    </div>
                                </div>
                                <p className="font-30 font-600 mb-0">{summary?.crossChannel}</p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="bg-white p-3 custom-shadow h-100 radius-6">
                                <div className="row g-3 align-items-center">
                                    <div className="col font-14 font-500 text-gray-64">Not Outreached</div>
                                    <div className="col-auto">
                                        <div className="bg-danger bg-opacity-10 ratio-32 rounded-3 d-flex justify-content-center align-items-center">
                                            <i className="bi bi-telephone-x text-danger font-18"></i>
                                        </div>
                                    </div>
                                </div>
                                <p className="font-30 font-600 mb-0">{summary?.notOutreached}</p>
                                <span className="font-14 font-400 text-gray-4b mb-0">{summary?.notOutreachedPercent}% gap</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SummaryStatsPanel;
